import React from 'react';
import classnames from 'classnames';
import { pick, escape } from 'lodash';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Translate, withLocalize } from 'react-localize-redux';
import { Map as LeafletMap, Marker, TileLayer } from 'react-leaflet';
import { isNullOrUndefined, isRepiWeb } from '../../store/storeFunctions';
import { getLanguage, apiPost, getHostApi } from '../../store/apiWrapper';
import Message from '../common/message';
import BbInput from '../styling/bbInput';
import RichTextEditor from '../common/richTextEditor';
import * as Yup from '../common/Yup';
import PhoneNumber from '../common/phoneNumber';
import UnderlinedTitle from '../common/underlinedTitle';

import './contact.scss';

const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

class ContactComponent extends React.Component {
    state = {
        content: "",
        error: false,
        success: false
    };

    render() {
        var agentLanguage = "";
        if (!isNullOrUndefined(this.props.user.authentication.profile))
            agentLanguage = this.props.user.authentication.profile.agentLanguage;
        else
            agentLanguage = getLanguage();

        return (
            <div className='content-root'>
                <div className="columns is-desktop">
                    <div className="column is-4-desktop contact-left-info-wrapper" style={{ fontSize: "1em" }}>
                        <div className="icon-wrap">
                            <FontAwesomeIcon className='svg-standard-color' icon="linkedin" size='3x' />
                        </div>
                        {this.renderContact(agentLanguage)}
                    </div>
                    {this.renderForm()}
                </div>
                {agentLanguage === "sk-SK" && !isRepiWeb() && this.renderSpecialCardSk()}
            </div>
        );
    }

    renderContact = (agentLanguage) => {
        return isRepiWeb()
            ? (agentLanguage === 'sk-SK' ? this.renderRepiSkContact() : this.renderRepiCzContact())
            : (agentLanguage === 'sk-SK' ? this.renderCribisSkContact() : this.renderCribisCzContact())

    }

    renderCribisCzContact = () => {
        return (
            <>
                <div className="contact-wrapper" style={{ overflow: 'hidden' }}>
                    <div>
                        <div><span className="contact-title">CRIF - Czech Credit Bureau, a.s.</span></div>
                        <div><span>Štětkova 1638/18, 140 00  Praha 4</span></div>
                        <div><span><Translate id="Contact.ICO" />: </span><span>26212242</span></div>
                        <div><span><Translate id="Contact.DIC" />: </span><span>CZ26212242</span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Tel" />:
                        </span><span><PhoneNumber value='+420-277-78-530' label='+420 277 778 530' /></span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Email" />:
                        </span><span><a href="mailto:info.cz@crif.com">info.cz@crif.com</a></span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Web" />:
                        </span><span><a className="bb-contact-links" href="http://www.crif.cz" target='_blank'>www.crif.cz</a>,{" "}
                                <a className="bb-contact-links" href="https://www.cribis.cz" target='_blank'>www.cribis.cz</a></span></div>
                    </div>
                </div>
                <div className="contact-wrapper" style={{ overflow: 'hidden', paddingTop: "1em" }}>
                    <div>
                        <div><span className="contact-title"><Translate id="Contact.Hotline" />:</span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Tel" />:
                        </span><span><PhoneNumber value='+420-277-78-530' label='+420 277 778 530' /></span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Mobile" />:
                        </span><span><PhoneNumber value='+420-737-152-074' label='+420 737 152 074' /></span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Email" />:
                        </span><span><a href="mailto:helpdesk.cz@crif.com">helpdesk.cz@crif.com</a></span></div>
                    </div>
                </div>
                <div className="contact-wrapper" style={{ overflow: 'hidden', paddingTop: "1em" }}>
                    <div className="contact-map-wrapper">
                        <LeafletMap scrollWheelZoom={false} center={[50.0599434, 14.4301718]} zoom="15">
                            <TileLayer
                                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={[50.0599434, 14.4301718]} />
                        </LeafletMap>
                    </div>
                </div>
            </>
        );
    }

    renderCribisSkContact = () => {
        return (
            <>
                <div className="contact-wrapper">
                    <div><span className="contact-title">CRIF - Slovak Credit Bureau, s.r.o.</span></div>
                    <div><span>Mlynské nivy 14, 821 09 Bratislava</span></div>
                    <div><span><Translate id="Contact.ICO" />: </span><span>35886013</span></div>
                    <div><span><Translate id="Contact.ICDPH" />: </span><span>SK2021842042</span></div>
                    <div><span><Translate id="Contact.DIC" />: </span><span>2021842042</span></div>
                    <div><span><Translate id="Contact.RegNumber" />: </span><span>31737/B</span></div>
                    <div className="contact-flex"><span><Translate id="Contact.Tel" />:
                    </span><span><PhoneNumber value='+421-2-5920-7537' label='+421 (02) 5920 7537' /></span></div>
                    <div className="contact-flex"><span><Translate id="Contact.Tel" />:
                    </span><span><PhoneNumber value='+421-2-5920-7500' label='+421 (02) 5920 7500' /></span></div>
                    <div className="contact-flex"><span><Translate id="Contact.Email" />:
                    </span><span><a href="mailto:info.sk@crif.com">info.sk@crif.com</a></span></div>
                    <div className="contact-flex"><span><Translate id="Contact.Web" />:
                    </span><span><a className="bb-contact-links" href="http://www.crif.sk" target='_blank'>www.crif.sk</a>,{" "}
                            <a className="bb-contact-links" href="https://www.cribis.sk" target='_blank'>www.cribis.sk</a></span></div>
                </div>
                <div className="contact-wrapper" style={{ overflow: 'hidden', paddingTop: "1em" }}>
                    <div>
                        <div><span className="contact-title"><Translate id="Contact.Hotline" />:</span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Tel" />:
                        </span><span><PhoneNumber value='+421-2-5920-7537' label='+421 (02) 5920 7537' /></span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Email" />:
                        </span><span><a href="mailto:helpdesk.sk@crif.com">helpdesk.sk@crif.com</a></span></div>
                    </div>
                </div>
                <div className="contact-wrapper" style={{ overflow: 'hidden', paddingTop: "1em" }}>
                    <div className="contact-map-wrapper">
                        <LeafletMap scrollWheelZoom={false} center={[48.1459823, 17.1260412]} zoom="15">
                            <TileLayer
                                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={[48.1459823, 17.1260412]} />
                        </LeafletMap>
                    </div>
                </div>
            </>
        );
    }

    renderRepiCzContact = () => {
        return (
            <>
                <div className="contact-wrapper" style={{ overflow: 'hidden' }}>
                    <div>
                        <div><span className="contact-title">CRIF - Registr platebních informací s. r. o.</span></div>
                        <div><span>Štětkova 1638/18, 140 00  Praha 4</span></div>
                        <div><span><Translate id="Contact.ICO" />: </span><span>05775809</span></div>
                        <div><span><Translate id="Contact.DIC" />: </span><span>CZ05775809</span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Tel" />:
                        </span><span><PhoneNumber value='+420-844-111-777' label='+420 844 111 777' /></span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Email" />:
                        </span><span><a href="mailto:info@repi.cz">info@repi.cz</a></span></div>
                        <div className="contact-flex"><span><Translate id="Contact.Web" />:
                        </span><span><a className="bb-contact-links" href="https://www.repi.cz/" target='_blank'>www.repi.cz</a></span></div>
                    </div>
                </div>
                <div className="contact-wrapper" style={{ overflow: 'hidden', paddingTop: "1em" }}>
                    <div className="contact-map-wrapper">
                        <LeafletMap scrollWheelZoom={false} center={[50.0599434, 14.4301718]} zoom="15">
                            <TileLayer
                                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={[50.0599434, 14.4301718]} />
                        </LeafletMap>
                    </div>
                </div>
            </>
        );
    }

    renderRepiSkContact = () => {
        return (
            <>
                <div className="contact-wrapper">
                    <div><span className="contact-title">CRIF - Slovak Credit Bureau, s.r.o.</span></div>
                    <div><span>Mlynské nivy 14, 821 09 Bratislava</span></div>
                    <div><span><Translate id="Contact.ICO" />: </span><span>35886013</span></div>
                    <div><span><Translate id="Contact.ICDPH" />: </span><span>SK2021842042</span></div>
                    <div><span><Translate id="Contact.DIC" />: </span><span>2021842042</span></div>
                    <div><span><Translate id="Contact.RegNumber" />: </span><span>31737/B</span></div>
                    <div className="contact-flex"><span><Translate id="Contact.Tel" />:
                    </span><span><PhoneNumber value='+421-2-5920-7537' label='+421 (02) 5920 7537' /></span></div>
                    <div className="contact-flex"><span><Translate id="Contact.Tel" />:
                    </span><span><PhoneNumber value='+421-2-5920-7500' label='+421 (02) 5920 7500' /></span></div>
                    <div className="contact-flex"><span><Translate id="Contact.Email" />:
                    </span><span><a href="mailto:info@crif.sk">info@crif.sk</a></span></div>
                    <div className="contact-flex"><span><Translate id="Contact.Web" />:
                    </span><span><a className="bb-contact-links" href="https://www.repi.sk" target='_blank'>www.repi.sk</a></span></div>
                </div>
                <div className="contact-wrapper" style={{ overflow: 'hidden', paddingTop: "1em" }}>
                    <div className="contact-map-wrapper">
                        <LeafletMap scrollWheelZoom={false} center={[48.1459823, 17.1260412]} zoom="15">
                            <TileLayer
                                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={[48.1459823, 17.1260412]} />
                        </LeafletMap>
                    </div>
                </div>
            </>
        );
    }

    renderForm = () => {
        return (
            <div className='column'>
                <div className='card card-special'>
                    <div className='card-body contact-form'>
                        <Formik
                            ref={(el) => this.formRef = el}
                            enableReinitialize={true}
                            validationSchema={this.createValidationSchema()}
                            validateOnChange={false}
                            validateOnBlur={false}
                            initialValues={{ email: "" }}
                            onSubmit={(values, { setSubmitting, setFieldValue }) => {
                                setSubmitting(false);
                                this.handleSubmit(values, setFieldValue)
                            }}
                        >
                            {({ errors }) => (
                                <Form >
                                    <div className="contact-title" style={{ paddingBottom: "2em" }}>
                                        {this.props.translate("Contact.Title")}
                                    </div>
                                    {this.state.success && <div className="contact-error-send">
                                        <Message type="success" message={this.props.translate("Contact.Form.Success")} />
                                    </div>}
                                    {this.state.error && <div className="contact-error-send">
                                        <Message type="error" message={this.props.translate("Feedback.Error.Send")} />
                                    </div>}
                                    {Object.keys(errors).length > 0 && <div className="column">
                                        <Message type="error" message={this.props.translate("Error.InvalidParams")}>
                                            {this.props.translate("Common.InvalidEmail")}
                                        </Message>
                                        {this.state.success && this.setState({ success: false })}
                                    </div>}
                                    <div className="columns">
                                        <div className="column is-12">
                                            <BbInput type='text' name='email' label={this.props.translate('Contact.Email')}
                                                placeholder={{ type: 'column' }} error={errors} />
                                        </div>
                                    </div>
                                    <RichTextEditor
                                        value={this.state.content}
                                        onChange={(value) => this.updateContent(value)}
                                    />
                                    <div className='columns m-0 is-centered has-text-centered' style={{ paddingTop: "2em" }}>
                                        <div className='column is-narrow'>
                                            <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                                type='submit'
                                                style={{ fontWeight: 600 }}
                                                disabled={this.state.sending || this.state.content.replace(/<(.|\n)*?>/g, '').trim().length === 0 ||
                                                    isNullOrUndefined(this.state.content)}
                                            >
                                                {this.state.sending ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Common.Send' />}
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }

    renderSpecialCardSk = () => {
        return (
            <div className='card card-special'>
                <div className='card-body contact-form-sales'>
                    <UnderlinedTitle header={this.props.translate("Contact.Sales")} />
                    <div className="columns is-tablet sale-fixed-height is-multiline is-centered">
                        <div className="column is-3-widescreen is-12-mobile is-6">
                            <SaleCard saleName="Slavoj Kleskeň, B.S.B.A." phone="+421-2-5920-7587" phoneLabel="+421 (02) 5920 7587"
                                mobile="+421-918-662-386" mobileLabel="+421 918 662 386"
                                email="s.klesken@crif.com" />
                        </div>
                        <div className="column is-3-widescreen is-12-mobile is-6">
                            <SaleCard saleName="Ing. Marcela Hideghétyová" phone="+421-2-5920-7588" phoneLabel="+421 (02) 5920 7588"
                                mobile="+421-918-971-195" mobileLabel="+421 918 971 195"
                                email="m.hideghetyova@crif.com" />
                        </div>
                        <div className="column is-3-widescreen is-12-mobile is-6">
                            <SaleCard saleName="Matej Repa" phone="+421-2-5920-7570" phoneLabel="+421 (02) 5920 7570"
                                mobile="+421-911-072-640" mobileLabel="+421 911 072 640"
                                email="m.repa@crif.com" />
                        </div>
                        <div className="column is-3-widescreen is-12-mobile is-6">
                            <SaleCard saleName="Mgr. Jozef Barina" phone="+421-2-5920-7569" phoneLabel="+421 (02) 5920 7569"
                                mobile="+421-911-407-274" mobileLabel="+421 911 407 274"
                                email="j.barina@crif.com" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    createValidationSchema = () => {
        const schema = {
            'email': Yup.string().trim().required(this.props.translate("Search.Common.Validation.WrongInput")).matches(EMAIL_REGEX, { message: this.props.translate("Search.Common.Validation.WrongInput") })
        };
        return Yup.object().shape(pick(schema, ['email']));
    }

    updateContent(value) {
        this.setState({ content: value })
    }

    handleSubmit(values, setFieldValue) {
        this.setState({ sending: true, error: false, success: false });
        apiPost(`${getHostApi()}/api/account/contact-form`, null,
            {
                message: escape(this.state.content),
                email: values.email
            },
            (data) => {
                if (data.data) {
                    this.setState({ error: false, sending: false, content: "", success: true });
                    setFieldValue("email", "");
                }
                else {
                    this.setState({ error: true, sending: false, success: false });
                }
            },
            _ => {
                this.setState({ error: true, sending: false, success: false });
            }
        );
    }
}

class SaleCard extends React.Component {

    render() {
        const { saleName, phone, phoneLabel, mobile, mobileLabel } = this.props;
        let email = this.props.email;

        if (!EMAIL_REGEX.test(email).valueOf())
            email = undefined;

        return (
            <div className={classnames('sale-card')}>
                <div className={classnames({ "sale-body": true })}>
                    <div><span>{saleName}</span></div>
                    <div className="sale-flex"><span><Translate id="Contact.Tel" />:</span><span><PhoneNumber value={phone} label={phoneLabel} /></span></div>
                    <div className="sale-flex"><span><Translate id="Contact.Mobile" />:</span><span><PhoneNumber value={mobile} label={mobileLabel} /></span></div>
                    {email && <div className="sale-flex"><span><Translate id="Contact.Email" />:</span><span><a href={`mailto:${email}`}>{email}</a></span></div>}
                </div>
            </div>
        )
    }

}

export default withLocalize(connect(
    state => ({ user: state.userContext }))(ContactComponent));
